import { render, staticRenderFns } from "./admin_header.vue?vue&type=template&id=057b60be&scoped=true"
import script from "./admin_header.vue?vue&type=script&lang=js"
export * from "./admin_header.vue?vue&type=script&lang=js"
import style0 from "./admin_header.vue?vue&type=style&index=0&id=057b60be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b60be",
  null
  
)

export default component.exports